import {
  Divider,
  DownloadLink,
  MainHeading,
  PolicyPageWrapper,
  TableTextContent,
  TitleTextContent,
} from '@rimactechnology/rimac-ui-lib';
import dynamic from 'next/dynamic';
import { Fragment } from 'react';

import { CookiePolicyCookiePolicyDynamicZone } from '@/api';

interface Props {
  data: CookiePolicyCookiePolicyDynamicZone[];
}

const UsercentricsEmbed = dynamic<{ showToggle: boolean }>(
  () =>
    Promise.resolve(({ showToggle }: { showToggle: boolean }) => (
      <div
        className="uc-embed"
        uc-data-version="all"
        {...(showToggle ? { 'uc-embed-show-toggle': 'true' } : {})}
      />
    )),
  { ssr: false },
);

export default function EnhancedPolicyPageWrapper({ data }: Props) {
  return (
    <PolicyPageWrapper>
      <Fragment>
        {data?.map((policy, index) => {
          switch (policy?.__typename) {
            case 'ComponentPoliciesMainHeading':
              return (
                <MainHeading
                  key={`componentPoliciesMainHeading-${index}`}
                  useCase="energy"
                  richText={policy.text}
                  parentIndex={index}
                />
              );
            case 'ComponentPoliciesDownloadLink':
              return (
                <DownloadLink
                  key={`componentPoliciesDownloadLink-${index}`}
                  label={policy.label || ''}
                  href={policy.link || ''}
                  useCase="energy"
                />
              );
            case 'ComponentPoliciesTableTextContent':
              return (
                <TableTextContent
                  key={`componentPoliciesTableTextContent-${index}`}
                  useCase="energy"
                  text={policy.richText}
                  parentIndex={index}
                  tableData={{
                    headings: (policy.tableHead || []).map(
                      (heading) => heading?.headingItem || '',
                    ),
                    values: (policy.tableRow?.table_rows?.data || []).map(
                      (row) =>
                        (row.attributes?.rows || []).map(
                          (item) => item?.item || '',
                        ),
                    ),
                  }}
                />
              );
            case 'ComponentPoliciesTitleTextContent':
              return (
                <TitleTextContent
                  key={`componentPoliciesTitleTextContent-${index}`}
                  richText={policy.text}
                  useCase="energy"
                  parentIndex={index}
                />
              );
            case 'ComponentPoliciesDivider':
              return <Divider key={`componentPoliciesDivider-${index}`} />;
            case 'ComponentSharedUcEmbed':
              return (
                <UsercentricsEmbed
                  key={`componentSharedUcEmbed-${index}`}
                  showToggle={policy.showToggle ?? false}
                />
              );
          }
        })}
      </Fragment>
    </PolicyPageWrapper>
  );
}
